/** Mirror of `socaity_schemas.platform.deployment`. */

import type { ServiceAddress } from '../definitions';
import { HostingPricingRule } from './pricing';

export type Provider = 'socaity' | 'runpod' | 'replicate' | 'scaleway' | 'azure' | 'other';

export class ContainerConfig {
  image: string | null;
  disk_gb: number | null;
  network_volume_id: string | null;
  volume_mount_path: string | null;
  ports: string | null;
  env: Record<string, string> | null;

  constructor(data: Record<string, any> = {}) {
    this.image = data.image ?? null;
    this.disk_gb = data.disk_gb != null ? Number(data.disk_gb) : null;
    this.network_volume_id = data.network_volume_id ?? null;
    this.volume_mount_path = data.volume_mount_path ?? null;
    this.ports = data.ports ?? null;
    this.env = data.env ?? null;
  }
}

/** One running instance of a service at one provider. */
export class Deployment {
  id: string | null;
  service_id: string | null;
  provider: Provider | string;
  region: string | null;
  /** ServiceAddress: { base_url, path, job_path } */
  address: ServiceAddress | Record<string, any> | null;
  specification_hash: string | null;
  /** ServiceContract / definition, loaded on `expand=deployments.contract`. */
  contract: Record<string, any> | null;
  container: ContainerConfig | Record<string, any> | null;
  pricing_rule_id: number | null;
  pricing_rule: HostingPricingRule | null;
  pat_token_id: string | null;
  hf_token_id: string | null;
  created_by: string | null;
  created_at: string | null;
  n_usages: number | null;
  n_usages_external: number | null;

  constructor(data: Record<string, any> = {}) {
    this.id = data.id ?? null;
    this.service_id = data.service_id ?? null;
    this.provider = data.provider || 'other';
    this.region = data.region ?? null;
    this.address = data.address ?? null;
    this.specification_hash = data.specification_hash ?? null;
    this.contract = data.contract ?? null;
    this.container = data.container
      ? (data.container instanceof ContainerConfig ? data.container : new ContainerConfig(data.container))
      : null;
    this.pricing_rule_id = data.pricing_rule_id ?? null;
    this.pricing_rule = data.pricing_rule
      ? (data.pricing_rule instanceof HostingPricingRule
        ? data.pricing_rule
        : new HostingPricingRule(data.pricing_rule))
      : null;
    this.pat_token_id = data.pat_token_id ?? null;
    this.hf_token_id = data.hf_token_id ?? null;
    this.created_by = data.created_by ?? null;
    this.created_at = data.created_at ?? null;
    this.n_usages = data.n_usages != null ? Number(data.n_usages) : null;
    this.n_usages_external = data.n_usages_external != null ? Number(data.n_usages_external) : null;
  }
}
